import * as React from "react";

function SvgIconObjectiveOffset(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.167 17c0 7.83-6.338 14.167-14.167 14.167-7.83 0-14.167-6.338-14.167-14.167C2.833 9.17 9.171 2.833 17 2.833c7.83 0 14.167 6.338 14.167 14.167zM17 27.833c-5.983 0-10.833-4.85-10.833-10.833 0-5.983 4.85-10.833 10.833-10.833 1.845 0 3.581.461 5.101 1.274h-.003a4.46 4.46 0 104.46 4.461v-.003A10.785 10.785 0 0127.834 17c0 5.983-4.85 10.833-10.833 10.833z"
        fill="#414042"
      />
      <path
        d="M0 0h2.833v5.667H0V0zM0 28.333h2.833V34H0v-5.667zM31.167 0H34v5.667h-2.833V0zM31.167 28.333H34V34h-2.833v-5.667zM2.833 0h2.834v2.833H2.833V0zM2.833 31.167h2.834V34H2.833v-2.833zM28.333 0h2.834v2.833h-2.834V0zM28.333 31.167h2.834V34h-2.834v-2.833z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgIconObjectiveOffset;
